<template>
  <div>
    <div class="row mt-0">
      <div class="col-12 col-md-6">
        <atom-select
          v-model="workloadFilter.user"
          title="User Scope"
          placeholder="Select Scope"
          label="name"
          :option="userScopeOptions"
        ></atom-select>
      </div>
    </div>
  </div>
</template>

<script>
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import mixins from "@/mixins"

export default {
  name: "MoleculeReportFilterTicket",
  components: { AtomInput, AtomSelect },
  mixins: [mixins],
  props: {
    value: {
      type: Object,
      required: true,
    },
    userScopeOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    workloadFilter: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit("input", newValue)
      },
    },
  },
}
</script>

<style></style>
